import { Injectable } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Subject } from 'rxjs';
import { PublicCustomer } from '../models/public-customer.model';
import { ClientForm } from '../models/client-form.model';
import { ClientField } from '../models/client-field.model';
import { CommunityUserExtended } from '@sb-tools/typescript/models/community-user-extended.model';
import { AttachmentBase } from '@sb-tools/typescript/models/attachment-base.model';
import { Field } from '@sb-tools/typescript/models/field.model';
import { FieldType } from '@sb-tools/typescript/enums/field-type.enum';

@Injectable({
    providedIn: 'root',
})
export class FormCommonDataService {
    attachmentsAddedSubject = new Subject<AttachmentBase[]>();
    backUrl: string;
    categoryUpdatedSubject = new Subject<number>();
    community: string;
    communityNameUpdatedSubject = new Subject<string>();
    customerSettings: PublicCustomer;
    form: ClientForm = new ClientForm();
    formInitSubject = new Subject<UntypedFormGroup>();
    formName: string;
    faqName: string;
    isFbApp: string;
    isReplyTemplatesModalOpened: boolean;
    isFromFaq: boolean;
    isInternal: boolean;
    isMessageContentLoaded: boolean;
    isSurveySent: boolean;
    language;
    menyProductUpdateSubject = new Subject<any>();
    surveyToken: string;
    user: CommunityUserExtended = new CommunityUserExtended();

    private focusableElementsTypes = [
        FieldType.textInput,
        FieldType.textArea,
        FieldType.select,
        FieldType.date,
        FieldType.emailInput,
        FieldType.numberInput,
        FieldType.region,
        FieldType.mobileNumber,
        FieldType.address,
        FieldType.accountNumber,
        FieldType.storeInfo,
        FieldType.menyProductName,
        FieldType.title,
        FieldType.message,
        FieldType.categories,
        FieldType.userIdentification,
        FieldType.userInfo,
        FieldType.ccUsers,
        FieldType.bccUsers,
        FieldType.outboundEmailAddress,
    ];

    setFocusOnFirstFocusableElement(elements: Field[] | ClientField[]) {
        const firstFocusableElementIndex = elements.findIndex((field) => {
            return this.focusableElementsTypes.includes(field.type);
        });

        if (firstFocusableElementIndex > -1) {
            elements[firstFocusableElementIndex].isNeedToFocus = true;
        }
    }

    updateCommunityName(name: string) {
        this.communityNameUpdatedSubject.next(name);
    }

    updateMenyProductModel(newValue) {
        this.menyProductUpdateSubject.next(newValue);
    }
}
